/// <reference path="../selectbox/selectbox.ts" />
/// <reference path="../../../../teva/datepicker/datepicker.ts" />

namespace OfficeGuy.Inputs {
    export class DateRange {
        static PageLoad() {
            DateRange.PopulateDateRanges();
        }

        static PopulateDateRanges(): void {
            if ($(".daterange").length == 0)
                return;

            var IsMonths = $(".daterange").hasClass("daterange-months");

            var Date_From_String = <string>$(".daterange-range-from").val();
            var Date_To_String = <string>$(".daterange-range-to").val();
            if (Date_From_String != null && Date_To_String != null && Date_From_String != '' && Date_To_String != '') {
                var Date_From = Teva.DatePicker.GetDateFromString(Date_From_String, IsMonths ? Teva.DatePickerMode.Month : Teva.DatePickerMode.Date);
                var Date_To = Teva.DatePicker.GetDateFromString(Date_To_String, IsMonths ? Teva.DatePickerMode.Month : Teva.DatePickerMode.Date);
                var Tab = "5"; // Date Range
                if ((IsMonths || (Date_From.getDate() == 1 && Date_To.getDate() == Teva.DatePicker.DaysInMonth(Date_To.getMonth() + 1, Date_To.getFullYear()))
                    && Date_From.getFullYear() == Date_To.getFullYear())) {
                    if (Date_From.getFullYear() == Date_To.getFullYear() && Date_From.getMonth() == 0 && Date_To.getMonth() == 11)
                        Tab = "4"; // Year
                    else if (Date_From.getFullYear() == Date_To.getFullYear() && Date_From.getMonth() == Date_To.getMonth() - 2 && Date_From.getMonth() % 3 == 0)
                        Tab = "3"; // Quarter
                    else if (Date_From.getFullYear() == Date_To.getFullYear() && Date_From.getMonth() == Date_To.getMonth() - 1 && Date_From.getMonth() % 2 == 0)
                        Tab = "2"; // Bimonthly
                    else if (Date_From.getFullYear() == Date_To.getFullYear() && Date_From.getMonth() == Date_To.getMonth())
                        Tab = "1"; // Month
                }
                Teva.SelectBox.GetInstance($("input.daterange-year-year")).SetValue(Date_To.getFullYear(), Date_To.getFullYear());
                
                $("input.daterange-year-year").closest("form.preventdirty").data("og-modified", false);
                DateRange.SelectTab(Tab);
            }
        }

        static ChangeDates(Year: string, Month: string, Months: number): void {
            if (Year == '' || Month == '')
                return;

            var IsMonths = $(".daterange").hasClass("daterange-months");
            var $Date_From = $(".daterange-range-from");
            var $Date_To = $(".daterange-range-to");

            var ToDate = new Date(Number(Year), Number(Month) + Months - 1, 0);
            var FromValue, ToValue;
            if (IsMonths) {
                FromValue = Teva.DatePicker.GetMonthAsStringFromParts(Month, Year);
                ToValue = Teva.DatePicker.GetMonthAsString(ToDate);
            }
            else {
                FromValue = Teva.DatePicker.GetDateAsStringFromParts("1", Month, Year);
                ToValue = Teva.DatePicker.GetDateAsString(ToDate);
            }
            if ($Date_From.val() != FromValue)
                $Date_From.val(FromValue).trigger('change');
            if ($Date_To.val() != ToValue)
                $Date_To.val(ToValue).trigger('change');
        }

        static SelectTab(Value) {
            var IsMonths = $(".daterange").hasClass("daterange-months");
            Teva.SelectBox.GetInstance($("input.daterange-period-period")).SetValueFromQueryMethod(Value);
            var Year = Teva.DatePicker.GetDateFromString(<string>$(".daterange-range-to").val(), IsMonths ? Teva.DatePickerMode.Month : Teva.DatePickerMode.Date).getFullYear().toString();
            if (Value == "1")
                DateRange.ChangeDates(Year, <string>$("input.daterange-month-month").val(), 1);
            else if (Value == "2")
                DateRange.ChangeDates(Year, <string>$("input.daterange-twomonths-month").val(), 2);
            else if (Value == "3")
                DateRange.ChangeDates(Year, <string>$("input.daterange-quarter-month").val(), 3);
            else if (Value == "4")
                DateRange.ChangeDates(Year, "1", 12);
            $(".daterange-month").toggle(Value == "1");
            $(".daterange-twomonths").toggle(Value == "2");
            $(".daterange-quarter").toggle(Value == "3");
            $(".daterange-year").toggle(Value != "5");
            $(".daterange-range").toggle(Value == "5");
        }

        static RefreshDateRange() {
            var Instance = Teva.SelectBox.GetInstance($("input.daterange-period-period"));
            var Value = Instance.SelectedValue;
            var Year = <string>$("input.daterange-year-year").val()
            if (Value == "1")
                DateRange.ChangeDates(Year, <string>$("input.daterange-month-month").val(), 1);
            else if (Value == "2")
                DateRange.ChangeDates(Year, <string>$("input.daterange-twomonths-month").val(), 2);
            else if (Value == "3")
                DateRange.ChangeDates(Year, <string>$("input.daterange-quarter-month").val(), 3);
            else if (Value == "4")
                DateRange.ChangeDates(Year, "1", 12);
        }
    }
}

$(document).on("Teva.PageLoad", function () {
    OfficeGuy.Inputs.DateRange.PageLoad();
});
